<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellVialsTotalNewPatients',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'scit_vials_new_patients',
          'slit_vials_new_patients',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
    },
  };
</script>
